import React from 'react';
import MyPlan from '@/pages/Products/VpsOciDetailPage/MyPlan/MyPlan.jsx';
import * as Styles from './VpsStoreLoaderPage.styles';
import LoaderPage from '@/pages/Loader/LoaderPage';

const VpsStoreLoaderPage = ({
  progress = null,
  title,
}) => (
  <>
    <MyPlan />
    <Styles.WrapperLoaderPage data-testid="vps-store-loader-page-wrapper">
      <LoaderPage
        progress={progress}
        title={title}
        borderRadius="16px"
      />
    </Styles.WrapperLoaderPage>
  </>
);

export default VpsStoreLoaderPage;
